var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('p',[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }